import auth from '@/services/auth'

const distributor = {
  create: async function (id, kind, serverUrl, streamKey) {
    try {
      const resp = await auth.sendWithToken({
        method: 'post',
        url: '/v1/events/' + id + '/distributors/' + kind,
        data: {
          server_url: serverUrl,
          stream_key: streamKey
        }
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  update: async function (id, targets) {
    // Create data
    var d = {}
    if (targets) d.targets = targets

    // Send
    try {
      const resp = await auth.sendWithToken({
        method: 'patch',
        url: '/v1/distributors/' + id,
        data: d
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  remove: async function (id) {
    // Send
    try {
      const resp = await auth.sendWithToken({
        method: 'delete',
        url: '/v1/distributors/' + id
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  imgSrc (kind) {
    return require('@/assets/img/' + kind + '.' + this._assetImageExt(kind))
  },
  _assetImageExt (kind) {
    return kind === 'facebook' || kind === 'instagram' || kind === 'linkedin' || kind === 'tiktok' || kind === 'rtmp' ? 'png' : 'svg'
  }
}

export default distributor
